const getMFADetails = txID => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  return `${geAPIV2}/mobilitygw/transaction/mfa/detail?txID=${txID}`;
};

const confirmMFA = () => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  return `${geAPIV2}/mobilitygw/transaction/mfa/confirm`;
};

export default {
  getMFADetails,
  confirmMFA,
};
